module.exports = __webpack_public_path__ + "img/56400.7b4ace56.jpg";